import type { IconData } from '@stacksjs/iconify-core'

export const cakeSlice: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M33.16 11.907a34 34 0 0 1 2.804-.606a3.72 3.72 0 0 1 3.249 1.031C41.307 14.401 45 19.16 45 27c0 7.423-.326 11.912-.606 14.397c-.179 1.59-1.417 2.757-3.01 2.912c-3.01.294-8.69.69-17.396.69c-8.7 0-14.368-.396-17.374-.69c-1.591-.155-2.829-1.321-3.008-2.91c-.263-2.338-.568-6.451-.603-13.116c-.004-.833.239-1.654.807-2.264c3.323-3.559 10.927-7.462 18.227-10.38\"/><path d=\"M34 15a6 6 0 1 1-12 0a6 6 0 0 1 12 0\"/><path d=\"M28 9c0-3.314-2.45-6-6-6m22 33H4m41-9H4\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cakeSlice
